<template>
    <div class="unilateral-chart" ref="myChart"></div>
</template>

<script>
import { get } from "@/api/index";


export default {
    data: function () {
        return {
            chartData: {},
            signature: this.$cookies.get('token'),
            myChart: ''
        }
    },
    props: [
        'sid'
    ],
    mounted() {
        this.myChart = this.$echarts.init(this.$el);
        this.getChartData();
    },
    methods: {
        initechart() {
            var axisColor = '#a8a7a9';
            var option = {
                tooltip: {
                    show: true,
                    axisPointer: {
                        type: 'cross'
                    },
                    trigger: 'axis',
                    formatter: function (datas) {
                        return datas[0].marker+' 仓位比 '+datas[0].value+'% </br>'+
                        datas[1].marker+' 收益 '+datas[1].value +"%";
                    }
                },
                backgroundColor: '#2a2d2e',
                textStyle: {
                    color: axisColor
                },
                color: ['#5c656f', '#db5634'],
                legend: [{
                    type: 'plain',
                    show: true,
                    data: ['仓位占比'],
                    left: '43%',
                    top: '10',
                    textStyle: {
                        color: axisColor
                    }
                },{
                    type: 'plain',
                    show:true,
                    data: ['收益'],
                    left: '50%',
                    top: '10',
                    textStyle: {
                        color: axisColor
                    },
                    borderColor: '#1aa094',
                    icon: 'circle'
                }],
                dataZoom: [{
                    type: 'inside',
                    start: 0,
                    end: 100,
                    rangeMode: ['0', '1']
                },{
                    type: 'slider',
                    start: 0,
                    end: 100,
                    show: false,
                    rangeMode: ['0', '1']
                }],
                grid: {
                    show: true,
                },
                xAxis: {
                    type: 'category',
                    data: this.chartData.time,
                    bottom: 0
                },
                yAxis: [{
                    position: 'left',
                    name: '仓位占比',
                    type: 'value',
                    axisLabel: {
                        formatter: '{value} %'
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#5a595a'
                        }
                    }
                },
                {
                    position: 'right',
                    name: '收益',
                    type: 'value',
                    axisLabel: {
                        formatter: '{value} %'
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#5a595a'
                        }
                    }
                }],

                series: [
                    {
                        type: 'bar',
                        name: '仓位占比',
                        data: this.chartData.position
                    },
                    {
                        type: 'line',
                        name: '收益',
                        data: this.chartData.earnings,
                        symbol: 'none',
                        yAxisIndex: 1,
                        lineStyle: {
                            width: 2
                        }
                    }
                ]
            };
            this.myChart.hideLoading();
            this.myChart.setOption(option);
        },

        // get chart data
        getChartData() {
            let url = this.$url_LN_local + '/get/chart/data';
            var s_list = [];
            s_list.push(this.sid);
            let param = {
                'sign': JSON.stringify(s_list),
                'token': this.signature
            };
            if (this.myChart) {
                this.myChart.showLoading();
            }

            get(url, param).then(res => {
                if (res.code === 200) {
                    this.chartData = res.data[this.sid];
                    console.log(res.data)
                    if (this.chartData) {
                        this.initechart();
                    }
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .unilateral-chart {
        width: 100%;
        height: 400px;
    }
</style>

